var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6876 13.7427L10.1765 1.74006C9.80937 1.06311 9.1826 0.658936 8.49999 0.658936C7.81732 0.658936 7.19056 1.06311 6.82349 1.74006L0.312361 13.7427C-0.0784453 14.4632 -0.104371 15.3765 0.24492 16.1263C0.594212 16.8757 1.26249 17.3414 1.98897 17.3414H15.0111C15.7375 17.3414 16.4058 16.8758 16.7552 16.1261C17.1044 15.3765 17.0784 14.4632 16.6876 13.7427ZM8.49999 15.321C7.90123 15.321 7.41591 14.75 7.41591 14.0456C7.41591 13.3412 7.90128 12.7702 8.49999 12.7702C9.09875 12.7702 9.58408 13.3412 9.58408 14.0456C9.58408 14.75 9.0987 15.321 8.49999 15.321ZM10.0026 6.45818L9.46867 10.6876C9.39007 11.3102 8.89736 11.7399 8.36823 11.6475C7.94072 11.5728 7.6202 11.1784 7.55429 10.702L6.97445 6.48096C6.83946 5.49816 7.40721 4.5727 8.24259 4.41388C9.07797 4.25507 9.86461 4.92301 9.99961 5.90581C10.025 6.09088 10.0241 6.28193 10.0026 6.45818Z",
    fill: "#FBAB1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.485567c9afe62cb487c450321a7a1545.svg";
export { ForwardRef as ReactComponent };